import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhone } from '@fortawesome/free-solid-svg-icons';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import { whatsappUrl } from '../../../../utils/whatsapp';

// 0711328001 -> 0711 328 001 for display only
export const formatPhone = (phone) => {
    const digits = String(phone || '').replace(/\D/g, '');
    return digits.length === 10 ? `${digits.slice(0, 4)} ${digits.slice(4, 7)} ${digits.slice(7)}` : phone;
};

/**
 * Phone number with call and WhatsApp actions.
 * Default: number on the left, round 36px action buttons on the right (for list rows).
 * compact: inline number + small icons (for headers and dense spots).
 */
const PhoneActions = ({ phone, label = 'next of kin', tag, compact = false, className = '' }) => {
    if (!phone) return null;

    if (compact) {
        return (
            <span className={`inline-flex items-center gap-2 ${className}`}>
                <a href={`tel:${phone}`} aria-label={`Call ${label}`} title={`Call ${label}`} className="hover:text-[#FF5733]">
                    <FontAwesomeIcon icon={faPhone} className="mr-1.5 text-gray-400" />{formatPhone(phone)}
                </a>
                <a href={whatsappUrl(phone)} target="_blank" rel="noopener noreferrer" aria-label={`WhatsApp ${label}`} title={`WhatsApp ${label}`} className="text-green-600 hover:text-green-700 text-base leading-none">
                    <FontAwesomeIcon icon={faWhatsapp} />
                </a>
            </span>
        );
    }

    return (
        <div className={`flex items-center justify-between gap-3 ${className}`}>
            <span className="text-sm text-[#2a2e30] tabular-nums">
                {tag && <span className="mr-2 text-xs font-medium text-gray-400">{tag}</span>}
                {formatPhone(phone)}
            </span>
            <span className="flex items-center gap-2 shrink-0">
                <a
                    href={`tel:${phone}`}
                    aria-label={`Call ${label}`}
                    title={`Call ${label}`}
                    className="w-9 h-9 rounded-full border border-gray-300 text-gray-600 flex items-center justify-center hover:border-[#FF5733] hover:text-[#FF5733] transition-colors"
                >
                    <FontAwesomeIcon icon={faPhone} />
                </a>
                <a
                    href={whatsappUrl(phone)}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={`WhatsApp ${label}`}
                    title={`WhatsApp ${label}`}
                    className="w-9 h-9 rounded-full border border-green-300 text-green-600 flex items-center justify-center text-lg hover:bg-green-50 transition-colors"
                >
                    <FontAwesomeIcon icon={faWhatsapp} />
                </a>
            </span>
        </div>
    );
};

export default PhoneActions;
